.space--block {
  width: 100%;
}
